/** Canonical production origin — keep in sync with Search Console / hosting. */
export const siteCanonicalOrigin = 'https://www.cleanpark.co.nz'

export const siteLegalName = 'Clean Park Morrinsville'

export const siteBrandTagline =
   'Car wash, dog wash, detailing, grooming & fleet — Morrinsville, Waikato'

export const siteTelephoneDisplay = '07 889 6823'

/** E.164 for structured data and tel: links */
export const siteTelephoneE164 = '+6478896823'

export const siteAddress = {
   street: '42 Studholme Street',
   locality: 'Morrinsville',
   region: 'Waikato',
   postalCode: '3300',
   country: 'NZ'
} as const

export const siteGeo = {
   latitude: -37.6588206,
   longitude: 175.5292908
} as const

export const siteFoundingYear = '1997'

export const siteLocale = 'en_NZ'

export const siteLanguage = 'en-NZ'

export const googleMapsPlaceUrl =
   'https://maps.google.com/?q=42+Studholme+Street+Morrinsville+3300'

/**
 * Builds an absolute URL for canonical, Open Graph, and JSON-LD.
 * @param pathname - Path beginning with `/` (e.g. `/contact`).
 */
export const buildAbsoluteSiteUrl = (pathname: string): string => {
   const normalized =
      pathname === '/'
         ? ''
         : pathname.startsWith('/')
           ? pathname
           : `/${pathname}`
   return `${siteCanonicalOrigin}${normalized}`
}
